import {observable} from "mobx";
import StockStore from "../Entities/StockStore";
import stockFiltrationMethodsLookupStore from "./StockFiltrationMethodsLookupStore";

export default class StockFiltrationSettingsStore {
    @observable filtrationMethod: string;
    @observable stores: StockStore[];
    onChange: () => void;
    constructor(onChange: () => void, filtrationMethodId?: string, stores: StockStore[] = []) {
        this.stores = stores;
        this.onChange = onChange;
        if (filtrationMethodId === undefined) {
            this.filtrationMethod = stockFiltrationMethodsLookupStore.first().id;
        }
        else {
            this.filtrationMethod = filtrationMethodId;
        }
    }

    get canSave(): boolean {
        return true;
    }
    
    serialize() {
        if (!this.canSave) return;
        return {
            filtrationMethod: this.filtrationMethod,
            stores: this.stores
                .filter(x => x.hasChanges)
                .map(x => ({storeId: x.storeId, isActive: x.isActive})),
        }
    }

    private getStore(storeId: string): StockStore {
        return this.stores.filter(x => x.storeId === storeId)[0];
    }

    getOrCreateStore(storeId: string): StockStore {
        const existsStore = this.getStore(storeId);
        if (existsStore) {
            return existsStore;
        }

        const avitoAccountStore = new StockStore(storeId, false, this.onChange);
        this.stores.push(avitoAccountStore);

        return avitoAccountStore;
    }
    
    setFiltrationMethod(filtrationMethodId: string) {
        this.filtrationMethod = filtrationMethodId;
        this.onChange();
    }
}